<template>
    <li class="nav-item nav-item-spaced d-flex align-items-center">
        <div class="position-relative">
            <div @click="dropdownVisible = true" class="d-flex align-items-center user-dropdown-toggle">
                <h6 class="px-0 m-0 mr-2 text-primary">{{ user.name }}</h6>
                <Gravatar :email="user.email" size="30" />
            </div>

            <div :class="{ show: dropdownVisible }" class="dropdown-menu dropdown-menu-sm dropdown-menu-right dropdown-menu-arrow p-3 user-dropdown">
                <div class="mb-2">
                    <h6 class="dropdown-header px-0 text-primary">{{ user.name }}</h6>
                    <small><span v-if="user.roles">{{ translateRoles(user.roles).join(', ') }}, </span>{{ user.email }}</small>
                    <div v-if="user.company" class="mt-1">{{ user.company.name }}</div>
                </div>

                <ul class="list-unstyled">
                    <li>
                        <RouterLink :to="{ name: 'profile' }" class="dropdown-item pointer-cursor">
                            <UserIcon />
                            <span>{{ $t('navigation.profile') }}</span>
                        </RouterLink>
                    </li>

                    <li>
                        <a @click="$emit('logout')" class="dropdown-item pointer-cursor">
                            <LogOutIcon />
                            <span>{{ $t('register.logout_link') }}</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </li>
</template>

<script>
    import Gravatar from './Gravatar.vue';
    import { LogOutIcon, UserIcon } from 'vue-feather-icons';
    import { translateRoles } from '../utils/auth';

    export default {

        components: {
            Gravatar,
            LogOutIcon,
            UserIcon
        },

        props: {
            user: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                dropdownVisible: false,
            };
        },

        mounted() {
            document.addEventListener('click', this.handleClickOutside);
        },

        methods: {
            translateRoles,

            handleClickOutside(event) {
                const dropdown = document.querySelector('.user-dropdown');
                const dropdownToggle = document.querySelector('.user-dropdown-toggle');

                if (!dropdown || !dropdownToggle) {
                    this.dropdownVisible = false;
                    return;
                }

                if (!dropdown.contains(event.target) && !dropdownToggle.contains(event.target)) {
                    this.dropdownVisible = false;
                }
            },
        },

        beforeDestroy() {
            document.removeEventListener('click', this.handleClickOutside);
        },
    };
</script>

<style lang="scss" scoped>

    .user-dropdown-toggle {
        cursor: pointer;
    }

    .user-dropdown {
        white-space: nowrap;

        h6.dropdown-header {
            font-size: 20px;
            line-height: 10px;
        }
    }
</style>
